import { findPayload } from '@execonline-inc/collections';
import clsx from 'clsx';
import { Maybe } from 'maybeasy';
import { observer } from 'mobx-react';
import { emptyFragment } from '../../../../../../../../EmptyFragment';
import Button from '../../../../../../../Form/Button';
import { LearningDesignsResource } from '../../../../../../Types';
import LearningCollectionEditStore from '../../../../Store';

interface Props {
  store: LearningCollectionEditStore;
  learningDesignsResource: LearningDesignsResource;
  learningDesignId: Maybe<number>;
}

function AddSectionButton({ store, learningDesignsResource, learningDesignId }: Props) {
  return learningDesignId
    .andThen((id) => findPayload(id, learningDesignsResource.payload.learningDesignResources))
    .map((resource) => (
      <div className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200">
        <div
          className={clsx(
            'flex justify-end items-center py-6 px-20',
            'mx-auto w-full max-w-clientPortalMaxWidth',
          )}
        >
          <Button
            type="button"
            value="Add a section"
            className={clsx(
              'rounded-md bg-green-600 py-2.5 px-8 text-sm font-semibold text-white',
              'disabled:opacity-75',
            )}
            onClick={() => store.chooseLearningDesign(resource)}
            intercomTarget="builder-add-section-button"
          />
        </div>
      </div>
    ))
    .getOrElse(emptyFragment);
}

export default observer(AddSectionButton);
